import React from 'react';

interface CheckStatusProps {
  status: 'approved' | 'rejected' | 'empty';
  withBorder?: boolean;
}

const CheckStepStatus: React.FC<CheckStatusProps> = ({
  status,
  withBorder
}) => {
  return (
    <div className={`${withBorder ? ' timeline-icon' : ''} bg-white`}>
      {status === 'approved' ? (
        <i className="fa-duotone fa-solid fa-circle-check text-success bg-white fs-2"></i>
      ) : status === 'rejected' ? (
        <i className="fa-duotone fa-solid fa-circle-xmark text-danger bg-white fs-2"></i>
      ) : (
        <i className="fa-duotone fa-solid fa-circle-dashed text-secondary bg-white fs-2"></i>
      )}
    </div>
  );
};

export default CheckStepStatus;
